// extracted by mini-css-extract-plugin
export default {"image":"Image_image__Jo8M7","loaded":"Image_loaded__NeadZ"};